const server = [{
  path: '/server',
  name: 'server',
  component: () => import('views/server/index.vue'),
  children: [
    //挂号
    {
      path: 'register',
      name: 'register',
      component: () => import('views/server/register/index.vue'),
      // component: () => import('views/server/register/department.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //报到
    {
      path: 'apptRegister',
      name: 'apptRegister',
      component: () => import('views/server/register/apptRegister.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //报到缴费
    {
      path: 'cheackPay',
      name: 'cheackPay',
      component: () => import('views/server/register/cheackPay.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //报到成功
    {
      path: 'cheackSucces',
      name: 'cheackSucces',
      component: () => import('views/server/register/cheackSucces.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //医生信息
    {
      path: 'docList',
      name: 'docList',
      component: () => import('views/server/register/docList.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //挂号列表
    {
      path: 'doclisttime',
      name: 'docListTime',
      component: () => import('views/server/register/docListTime.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //问卷调查
    {
      path: 'question',
      name: 'question',
      component: () => import('views/server/outpatient/question.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //挂号列表
    {
      path: 'detailList',
      name: 'detailList',
      component: () => import('views/server/register/detailList.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },

    //挂号详情
    {
      path: 'details',
      name: 'details',
      component: () => import('views/server/register/details.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true
      }
    },
    //挂号详情
    {
      path: 'success',
      name: 'success',
      component: () => import('views/server/register/success.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true
      }
    },
    //缴费列表
    {
      path: 'payList',
      name: 'payList',
      component: () => import('views/server/pay/payList.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //缴费详情
    {
      path: 'payDetails',
      name: 'payDetails',
      component: () => import('views/server/pay/payDetails.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //缴费成功页
    {
      path: 'paySuccess',
      name: 'paySuccess',
      component: () => import('views/server/pay/paySuccess.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true
      }
    },
    {
			path: 'socPay',
			name: 'socPay',
			component: () => import('views/server/pay/socPay.vue'),
			meta: {
				child: true,
				showtabbarfalse: true,
				login: true
			}
		},
		{
			path: "/socPayList",
			name: 'socPayList',
			component: () => import('views/server/pay/socPayList.vue'),
			meta:{
				child: true,
				showtabbarfalse: true,
				login: true
			},
		},
		{
			path: '/onlineInsurancePay',
			name: 'onlineInsurancePay',
			component: () => import('views/server/pay/onlineInsurancePay'),
			meta:{
				child: true,
				showtabbarfalse: true,
				login: true
			},
		},
		{
			path: '/authFail',
			name: 'authFail',
			component: () => import('views/server/pay/authFail'),
			meta:{
				child: true,
				showtabbarfalse: true,
				login: true
			},
		},
		{
			path: '/onlineInsuranceStatus',
			name: 'onlineInsuranceStatus',
			component: () => import('views/server/pay/onlineInsuranceStatus'),
			meta:{
				child: true,
				showtabbarfalse: true,
				login: true
			},
		},
    //挂号记录列表页
    {
      path: 'registerList',
      name: 'registerList',
      component: () => import('views/server/register/registerList.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //挂号记录详情页
    {
      path: 'registerDetail',
      name: 'registerDetail',
      component: () => import('views/server/register/registerDetail.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //报告列表
    {
      path: 'reportList',
      name: 'reportList',
      component: () => import('views/server/report/index.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    {
      path: 'reportDetail',
      name: 'reportDetail',
      component: () => import('views/server/report/reportDetail.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    {
      path: 'cheackUpDetail',
      name: 'cheackUpDetail',
      component: () => import('views/server/report/cheackUpDetail.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    {
      path: 'cheackOutDetail',
      name: 'cheackOutDetail',
      component: () => import('views/server/report/cheackOutDetail.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      }
    },
    //已缴费详情
    {
      path: 'paidDetail',
      name: 'paidDetail',
      component: () => import('views/server/pay/paidDetail.vue'),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true
      }
    },
    {
      path: "authorization",
      name: "authorization",
      component: () => import("views/server/authorization/index.vue"),
      meta: {
        child: true,
        showtabbarfalse: true,
        login: true,
      },
    },
    // //家庭医生
    // {
    //   path: 'familyDoc',
    //   name: 'familyDoc',
    //   component: () => import('views/server/familyDoc/familyDoctor/index.vue'),
    //   meta: {
    //     child: true,
    //     showtabbarfalse: true,
    //     login: true
    //   }
    // },
  ],
  meta: {}
},
  {
  path: '/server/familyDoctor',
  name: 'familyDoctor',
  component: () => import('views/server/familyDoc/familyDoctor/index'),
  children: [{
      path: '',
      redirect: '/server/familyDoctor/person'
    },
    {
      path: '/server/familyDoctor/person',
      name: 'familyDoctorPerson',
      component: () => import('views/server/familyDoc/familyDoctor/person'),
      meta: {
        title: '个人基本信息表',
        showtabbarfalse: true,
        child: true,
      },
    },
    {
      path: '/server/familyDoctor/health',
      name: 'familyDoctorHealth',
      component: () => import('views/server/familyDoc/familyDoctor/health'),
      meta: {
        title: '个人基本信息表',
        showtabbarfalse: true,
      },
    },
    {
      path: '/server/familyDoctor/live',
      name: 'familyDoctorLive',
      component: () => import('views/server/familyDoc/familyDoctor/live'),
      meta: {
        title: '个人基本信息表',
        showtabbarfalse: true,
      },
    }
  ]
}, ]

export default server
